<template>
	<div class="sp-template">
		<div class="h-title">渠道设置</div>
		<el-card class="box-card">
			<div slot="header" class="clearfix">
				<el-form :inline="true" :model="conditions" class="header-search__form" size="small" label-width="90px">
					<el-form-item label="状态">
						<el-select v-model="conditions.status" @change="search()" clearable>
							<el-option label="全部" value="all"></el-option>
							<el-option label="启用" value="1"></el-option>
							<el-option label="停用" value="0"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="公开状态">
						<el-select v-model="conditions.open" @change="search()" clearable>
							<el-option label="全部" value="all"></el-option>
							<el-option label="公开" value="1"></el-option>
							<el-option label="不公开" value="0"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="渠道">
						<el-input v-model="conditions.search" placeholder="请输入渠道中文名" clearable @change="search()"></el-input>
					</el-form-item>
					<div class="search-form__buttons">
						<el-button v-if="in_configs(70304)" type="primary" size="small" @click="search()">搜 索</el-button>
						<el-button v-if="in_configs(70304)" size="small" @click="reset()">清 空</el-button>
					</div>
				</el-form>
			</div>
			<div class="table-operate__buttons">
        <el-tabs v-model="conditions.type" @tab-click="search">
          <el-tab-pane label="空运" name="AIR_SHIPPING"></el-tab-pane>
          <el-tab-pane label="海运" name="SEA_SHIPPING"></el-tab-pane>
          <el-tab-pane label="铁运" name="RAILWAY_SHIPPING"></el-tab-pane>
        </el-tabs>
        <div class="button-groups">
					<el-button v-if="in_configs(70301)" size="small" @click="addChannel()">添加渠道</el-button>
				</div>
			</div>
			<el-table :data="channelData" stripe border style="width: 100%">
				<el-table-column prop="type" label="渠道类型" :formatter="formatType"></el-table-column>
				<el-table-column prop="code" label="渠道代码"></el-table-column>
				<el-table-column prop="nameCN" label="渠道中文名"></el-table-column>
				<el-table-column prop="nameEN" label="渠道英文名"></el-table-column>
				<el-table-column prop="print" label="是否面单打印" :formatter="formatPrint"></el-table-column>
				<el-table-column prop="status" label="状态" :formatter="formatStatus"></el-table-column>
				<el-table-column prop="operator" label="操作者"></el-table-column>
				<el-table-column prop="effectiveTime" label="生效时间"></el-table-column>
				<el-table-column prop="modifyTime" label="修改时间"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button type="text" size="mini" v-if="in_configs(70302)" @click="editChannel(scope.$index, scope.row)">编辑</el-button>
						<!-- <i v-if="in_configs(70303)" class="el-icon-delete" @click="deleteChannel(scope.$index, channelData)"></i> -->
						<el-button type="text" v-if="in_configs(70305)" size="mini" @click="addFarawayZip(scope.$index, scope.row)">添加偏远邮编</el-button>
					</template>
				</el-table-column>
			</el-table>
			<!-- 分页 -->
			<el-pagination background 
				@size-change="handleSizeChange" 
        @current-change="handleCurrentChange" 
        :current-page="currentPage" 
        :page-sizes="[10, 20, 50, 100]" 
        :page-size="pageSize" 
        layout="total, sizes, prev, pager, next, jumper" 
        :total = "parseInt(total)">
			</el-pagination>
			<el-dialog title="渠道信息" :visible.sync="dialogFormVisible" top="8vh" :before-close="emptyForm" width="1000px">
				<el-form :model="channelForm" :rules="rules" ref="channelForm" status-icon size="small" :label-width="formLabelWidth">
					<el-row>
						<el-col :span="12">
							<el-form-item label="渠道代码"  prop="code">
								<el-input v-model="channelForm.code" auto-complete="off" placeholder="渠道代码" clearable></el-input>
							</el-form-item>
							<el-form-item label="渠道中文名"  prop="nameCN">
								<el-input v-model="channelForm.nameCN" auto-complete="off" placeholder="渠道中文名" clearable></el-input>
							</el-form-item>
							<el-form-item label="重量单位"  prop="unitWeight">
								<el-select name="unitWeight" v-model="channelForm.unitWeight" filterable clearable placeholder="请选择重量单位">
										<el-option v-for="(weightUnit, index) in weightUnits" :value="weightUnit.value" :key="index" :label="weightUnit.name"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="整货最小重量"  prop="minTotalWeight">
								<el-input v-model="channelForm.minTotalWeight" auto-complete="off" placeholder="整货最小重量" clearable></el-input>
							</el-form-item>
							<el-form-item label="整货最小体积" >
								<el-input v-model="channelForm.minTotalVolume" auto-complete="off" placeholder="整货最小体积" clearable>
									<template slot="append">cm³</template>
								</el-input>
							</el-form-item>
							<el-form-item label="单件最大重量" >
								<el-input v-model="channelForm.maxWeightPerCarton" auto-complete="off" placeholder="单件最大重量" clearable></el-input>
							</el-form-item>
							<el-form-item label="单件最小重量" >
								<el-input v-model="channelForm.minWeightPerCarton" auto-complete="off" placeholder="单件最小重量" clearable></el-input>
							</el-form-item>
							<el-form-item label="单件最小体积" >
								<el-input v-model="channelForm.minVolumePerCarton" auto-complete="off" placeholder="单件最小体积" clearable>
									<template slot="append">cm³</template>
								</el-input>
							</el-form-item>
							<el-form-item label="目的国家"  prop="countryCode">
								<el-select v-model="channelForm.countryCode" multiple filterable clearable placeholder="请选择目的国家(可多选)">
									<el-option
										v-for="(item, index) in countryCodes"
										:key="index"
										:label="item.nameCn"
										:value="item.code">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="仓库"   prop="warehouseId">
								<el-select v-model="channelForm.warehouseId" multiple>
									<el-option v-for="item in warehouses" :key="item.id" :label="item.name" :value="item.id"></el-option>
								</el-select>
							</el-form-item>
					<el-form-item label="供应商名称"  prop="supplierId" >
					<el-select @change="changeSupplier()" v-model="supplierId" filterable clearable placeholder="请选择供应商名称">
                  <el-option v-for="(c,i) in channelProvider" :key="i" :label="c.name" :value="c.id"></el-option>
					</el-select>
					</el-form-item>
				<el-form-item label="供应商产品名称"  prop="supplierChannelCode" >
				<el-select v-model="supplierChannelCode" filterable clearable placeholder="请选择产品名称">
				<el-option v-for="(c,i) in supplierChannelCodes" :value="c.code" :key="i" :label="c.name"></el-option>
				</el-select>
				</el-form-item>
				<el-form-item label="分区类型" >
					<el-select v-model="channelForm.calculateChargeType" filterable clearable placeholder="请选择分区类型">
						<el-option value="ZIPCODE" label="按邮编计费"></el-option>
						<el-option value="FBACODE" label="按仓码计费"></el-option>
					</el-select>
				</el-form-item>

						</el-col>
						<el-col :span="12">
							<el-form-item label="渠道类型"  prop="type">
								<el-select v-model="channelForm.type" filterable clearable placeholder="请选择渠道类型">
									<el-option
										v-for="(item, index) in types"
										:key="index"
										:label="item.label"
										:value="item.value">
									</el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="渠道英文名"  prop="nameEN">
								<el-input v-model="channelForm.nameEN" auto-complete="off" placeholder="渠道英文名" clearable></el-input>
							</el-form-item>
							<el-form-item label="计泡方式"  prop="billedWeightCalculationMethod">
								<el-select v-model="channelForm.billedWeightCalculationMethod" clearable placeholder="请选择计泡方式">
									<el-option
										v-for="(item, index) in bubbleMethods"
										:key="index"
										:label="item.desc"
										:value="item.value">
									</el-option>
								</el-select>
								<el-tooltip v-if="channelForm.billedWeightCalculationMethod == 'HALF_BUBBLE'" class="billWeightTips" effect="dark" 
									content="前提 体积重大于实重，公式 （实重 + 体积重）/ 2" placement="top">
									<i class="el-icon-question"></i>
								</el-tooltip>
								<el-tooltip v-if="channelForm.billedWeightCalculationMethod == 'ONE_THIRD_BUBBLE'" class="billWeightTips" effect="dark" 
									content="前提 体积重大于实重，公式（体积重 - 实重）/ 3 + 实重" placement="top">
									<i class="el-icon-question"></i>
								</el-tooltip>
							</el-form-item>
							<el-form-item label="体积重计算比率"  prop="volumeWeightCalculationRadio">
								<el-input v-model="channelForm.volumeWeightCalculationRadio" auto-complete="off" placeholder="体积重计算比率" clearable></el-input>
							</el-form-item>
								<el-form-item label="参考时效"  prop="estimateTransitTime">
								<el-input v-model="channelForm.estimateTransitTime" auto-complete="off" placeholder="参考时效(单位：天)，如：7-15" clearable></el-input>
							</el-form-item>
							<el-form-item label="备注" >
								<el-input v-model="channelForm.remarks" auto-complete="off" placeholder="备注"></el-input>
							</el-form-item>
							<el-form-item label="重量提成单价" >
								<el-input v-model="channelForm.commissionPrice" auto-complete="off" placeholder="重量提成单价"></el-input>
							</el-form-item>
							<el-form-item label="毛利提成比率" >
								<el-input v-model="channelForm.commissionRate" auto-complete="off" placeholder="毛利提成比率"></el-input>
							</el-form-item>

							<el-form-item label="是否面单打印" >
								<el-radio v-model="channelForm.print" label="1">是</el-radio>
								<el-radio v-model="channelForm.print" label="0">否</el-radio>
							</el-form-item>
							<el-form-item label="是否启用" >
								<el-radio v-model="channelForm.status" label="1">是</el-radio>
								<el-radio v-model="channelForm.status" label="0">否</el-radio>
							</el-form-item>
							<el-form-item label="是否公开" >
								<el-radio v-model="channelForm.open" label="1">是</el-radio>
								<el-radio v-model="channelForm.open" label="0">否</el-radio>
							</el-form-item>
							<el-form-item label="体积比率" >
								<el-input v-model="channelForm.volumeActualWeightRatio" auto-complete="off" placeholder="体积比率"></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-form-item label="销售价" >
								<div><i class="el-icon-circle-plus-outline"  @click="addPriceDefinition()" title="添加价格"></i></div>
							</el-form-item>
						</el-col>
						<el-col :span="24">
							<el-table v-show="channelForm.priceDefinitions && channelForm.priceDefinitions.length" :data="channelForm.priceDefinitions" style="width: 100%">
									<el-table-column label="日期">
										<template slot-scope="scope">
											<span>{{scope.row.effectiveFrom}}</span> 至 {{scope.row.effectiveTo}}
										</template>
									</el-table-column>
									<el-table-column label="操作" width="100">
										<template slot-scope="scope">
											<i class="el-icon-edit-outline" @click="editPriceDefinition(scope.row)" title="更改"></i>
											<i class="el-icon-delete" v-if="scope.row.id==''" @click="deletePrice(scope.$index, channelForm.priceDefinitions)" title="删除"></i>
										</template>
									</el-table-column>
									<el-table-column label="状态" width="50">
										<template slot-scope="scope">
											<i :class='{checkColor : scope.row.id && scope.row.id !== "" && currentEffectivePriceId !== "" && scope.row.id == currentEffectivePriceId}' class="el-icon-circle-check"></i>
										</template>
									</el-table-column>
								</el-table>
						</el-col>
					</el-row>
					<definition 
						:aggregateId = "channelForm.id" 
						:weightUnit = "channelForm.unitWeight"
						:minBillableWeight = "channelForm.minTotalWeight"
						:dialogDefinitionVisible = "dialogDefinitionVisible" 
						:currentLayerIndex = "priceLayerIndex" 
						:BasicVariables = "basicVariable" 
						:initData = "priceDefinition" 
						@getDialogDefinitionVisible = "close"
						@callback = "getPriceDefinition"/>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button size="small" @click="resetForm('channelForm')">取 消</el-button>
					<el-button size="small" type="primary" @click="createChannel('channelForm')">确 定</el-button>
				</div>
			</el-dialog>
		</el-card>
		<!-- 添加偏远邮编 -->
		 <el-dialog title="添加偏远邮编" :visible.sync="ZipisShow" width="40%" >
			 	<el-form :v-model="sendPyZipObj"  status-icon ref="ruleForm" label-width="100px" class="demo-ruleForm">
						<el-form-item label="偏远邮编" prop="zipcode">
							<el-input type="textarea" v-model="sendPyZipObj.zipcode" :row="2"></el-input>
						</el-form-item>
						<el-form-item label="超偏远邮编" prop="zipcodecpy" ref="cpyref">
							<el-input type="textarea"  v-model="sendPyZipObj.zipcodecpy" :row="2"></el-input>
						</el-form-item>
					</el-form>
					<span slot="footer" class="dialog-footer">
					<el-button @click="saveZip('ruleForm')" size="small" type="primary">保存</el-button>
				</span>
		 </el-dialog>	 
	</div>
</template>
<script>
import definition from "./definition";
import {farwayZip,queryDefalutFarwayZip} from '@/util/batchAPI'
export default {
  data() {
		var checkDuplicateMsg = (rule, value, callback) => {
			if (value) {
				this.$request1({
				  method: 'POST',
          url: '/system/channel/check',
					params: {
						code: this.channelForm.code,
						nameCN: this.channelForm.nameCN,
						nameEN: this.channelForm.nameEN,
						id: this.channelForm.id
					}
				}).then(response => {
					if(response.data.message == "Duplicate code"){
						callback(new Error('渠道编码已存在！'));
					}else if(response.data.message == "Duplicate nameCN"){
						callback(new Error('渠道中文名已存在！'));
					}else if(response.data.message == "Duplicate nameEN"){
						callback(new Error('渠道英文名已存在！'));
					}else{
            callback();
          }
				}).catch(error => {
					console.log(error);
				})
			}
		};
		var checkVolumeWeightCalculationRadio = (rule, value, callback) => {
			if(value) {
				var pattern = /^[1-9]+.?[0-9]*$/;
				if(!pattern.test(value)){
					return callback(new Error('体积重计算比率必须大于0'));
				}else{
					callback();
				}
			}
		}
    return {
			ZipisShow:false,// 偏远邮编弹窗显示变量  
			sendPyZipObj:{
				zipcode:'',
				zipcodecpy:'',
				channelId:'',
			},
			isEdit: false,
			hiddenYesOrNo: false,
			priceLayerIndex: 0,
			basicVariable: [],
			priceDefinition: {},
			salesPriceDefineds: {},
			dialogDefinitionVisible: false,
			conditions: {
				search: "",
				type: "AIR_SHIPPING",
				status: "1",
				open: ""
			},
			currentEffectivePriceId: "",
			channelData: [],
			countryCodes: [],
			bubbleMethods: [],
			weightUnits: [
				{ name: "KG", value: "KG" },
				{ name: "Pounds", value: "POUNDS" },
				{ name: "Ounce", value: "OZ" }
			],
      channelForm: {
        id: "",
        code: "",
        type: "",
        nameEN: "",
        maxWeightPerCarton: "",
        minWeightPerCarton: "",
        minVolumePerCarton: "",
        open: "1",
        nameCN: "",
        unitWeight: "",
        estimateTransitTime: "",
        countryCode: [],
        minTotalWeight: "",
        minTotalVolume: "",
        volumeWeightCalculationRadio: "6000",
        billedWeightCalculationMethod: "",
        remarks: "",
        status: "1",
        print: "1",
        operator: "",
        priceDefinitions: [],
		warehouseId: [],
		supplierId:'',
		supplierChannelCode:'',
		commissionPrice: '',
		commissionRate: '',
		volumeActualWeightRatio: 0,
		calculateChargeType: 'ZIPCODE'
	  },
	  channelProvider:[],
		supplierChannelCodes:[],
		supplierId:null,
		supplierChannelCode:null,
      warehouses:[],
      warehouseMap: {},
      currentPage: 1, // 当前是第几页
      pageSize: 10, // 每页显示条目个数
      total: 0, // 总条目数
      dialogFormVisible: false,
			formLabelWidth: "130px",
			types: [
				{value: 'SEA_SHIPPING', label: '海运'},
				{value: 'AIR_SHIPPING', label: '空运'},
				{value: 'RAILWAY_SHIPPING', label: '铁运'}
			],
			rules: {
				code: [
					{ required: true, message: "请输入渠道编码", trigger: "blur" },
					{validator: checkDuplicateMsg, trigger: 'blur'}
				],
				type: [
					{ required: true, message: "请选择渠道类型", trigger: "change" }
				],
				unitWeight: [
					{ required: true, message: "请选择重量单位", trigger: "change" }
				],
				volumeWeightCalculationRadio: [
					{ required: true, message: "请输入体积重计费比率", trigger: "blur" },
					{ validator: checkVolumeWeightCalculationRadio, trigger: 'blur'}
				],
				billedWeightCalculationMethod: [
					{ required: true, message: "请选择计泡方式", trigger: "change"}
				],
				minTotalWeight: [
					{ required: true, message: "请输入整货最小重量", trigger: "blur" }
				],
				nameEN: [
					{ required: true, message: "请输入渠道英文名", trigger: "blur" },
					{validator: checkDuplicateMsg, trigger: 'blur'}
				],
				nameCN: [
					{ required: true, message: "请输入渠道中文名", trigger: "blur" },
					{validator: checkDuplicateMsg, trigger: 'blur'}
				],
				estimateTransitTime: [
					{ required: true, message: "请输入参考时效", trigger: "blur" }
				],
				countryCode: [
					{ required: true, message: "请选择目的国家(可多选)", trigger: "change" }
                ],
                warehouseId: [
					{ required: true, message: "请选择仓库(可多选)", trigger: "change" }
                ]
			}
    };
  },
  components: {
    definition
  },
  created() {
		setTimeout(() => {
			this.initChannel(this.conditions.search, this.conditions.type, this.conditions.status, this.conditions.open, this.currentPage, this.pageSize)
				if(this.basicVariable.length == 0){
					this.initBasicVariable();
				}
				this.initBubbleMethod()
				this.queryWarehouses();	
				this.loading = false;
				this.querySupplierProduct();
			}, 2000);
	},
  computed: {
    //权限
    configs() {
      let conf = JSON.parse(sessionStorage.configs),
        arr = [];
      conf.forEach((d, i) => {
        arr.push(d.name);
      });
      return arr;
    }
  },
  methods: {
		queryWarehouses(){
			let _this = this;
			this.$request1({
					method: 'get',
					url: '/warehouse/all',
					params: {
					}
			})
			.then(response => {
					this.warehouses = response.data;
					this.warehouses.forEach(a => {
							_this.warehouseMap[a.id] = a.name;
					});
			})
			.catch(error => {
				console.log(error);
			});
    },
		addChannel() {
			this.initCountry();
			this.dialogFormVisible = true
		},
		// 获取计泡方式枚举
		initBubbleMethod() {
			this.$request1({
        type: 'GET',
        url: '/system/channel/getBubbleMethod',
        xhrFields: {
          withCredentials: true
        }
      })
			.then(response => {
				if(response.data && response.data.length > 0) {
					this.bubbleMethods = response.data
				} else{
					this.$notify.warning({
						title: '提示',
						message: '获取计泡方式失败！'
					})
				}
			})
			.catch(error => {
				console.log(error);
			});
		},
		// 获取价格定义基本变量
		initBasicVariable() {
			this.$request1({
        type: 'GET',
        url: '/system/channel/getVariable',
        xhrFields: {
          withCredentials: true
        }
      })
			.then(response => {
				this.basicVariable = response.data;
			})
			.catch(error => {
				console.log(error);
			});
		},
		// 获取国家列表
    initCountry() {
      this.$request1({
        type: 'GET',
        url: '/country',
        xhrFields: {
          withCredentials: true
        }
      })
			.then(response => {
				this.countryCodes = response.data.data;
			})
			.catch(error => {
				console.log(error);
			});
    },
		// 查询当前有效价格ID
		findCurrentEffectivePriceDefinition (channelId){
			if(channelId && channelId != ""){
				this.$request1({
					type: 'GET',
					url: '/system/channel/findEffective/' + channelId + '',
					xhrFields: {
						withCredentials: true
					}
				})
				.then(res => {
					if(res.data.success){
						this.currentEffectivePriceId = res.data.data;
					}else{
						this.$message({
							message: res.data.message,
							type: 'error'
						});
					}
					
				})
				.catch(error => {
					console.log(error);
				});
			}
		},
		formatType(data) {
			switch (data.type) {
				case 'SEA_SHIPPING':
					return '海运';
					break;
				case 'AIR_SHIPPING':
					return '空运';
					break;
				case 'RAILWAY_SHIPPING':
					return '铁运';
					break;
			}
    },
		formatStatus(data) {
      return data.status == "1" ? "启用" : "停用";
    },
		formatPrint(data) {
			return data.print == "1" ? "是" : "否";
		},
		close(val) {
			this.dialogDefinitionVisible = val
    },
		// 创建/修改
		createChannel(formName) {
			this.$refs[formName].validate((valid) => {
				if(valid) {
					let channelForm = {};
					channelForm.id = this.channelForm.id;
					channelForm.code = this.channelForm.code;
					channelForm.type = this.channelForm.type;
					channelForm.nameEN = this.channelForm.nameEN;
					channelForm.maxWeightPerCarton = this.channelForm.maxWeightPerCarton;
					channelForm.minWeightPerCarton = this.channelForm.minWeightPerCarton;
					channelForm.minVolumePerCarton = this.channelForm.minVolumePerCarton;
					channelForm.open = parseInt(this.channelForm.open);
					channelForm.nameCN = this.channelForm.nameCN;
					channelForm.unitWeight = this.channelForm.unitWeight;
					channelForm.estimateTransitTime = this.channelForm.estimateTransitTime;
					channelForm.countryCode = this.channelForm.countryCode.join();
					channelForm.minTotalWeight = this.channelForm.minTotalWeight;
					channelForm.minTotalVolume = this.channelForm.minTotalVolume;
					channelForm.volumeWeightCalculationRadio = this.channelForm.volumeWeightCalculationRadio;
					channelForm.billedWeightCalculationMethod = this.channelForm.billedWeightCalculationMethod;
					channelForm.remarks = this.channelForm.remarks;
					channelForm.status = parseInt(this.channelForm.status);
					channelForm.print = parseInt(this.channelForm.print);
					channelForm.operator = this.channelForm.operator;
					channelForm.priceDefinitions = this.channelForm.priceDefinitions;
					channelForm.warehouseIds = this.channelForm.warehouseId;

					channelForm.commissionPrice = this.channelForm.commissionPrice;
					channelForm.commissionRate = this.channelForm.commissionRate;
					channelForm.volumeActualWeightRatio = this.channelForm.volumeActualWeightRatio;
					channelForm.calculateChargeType = this.channelForm.calculateChargeType;
					if(channelForm.priceDefinitions.length == 0){
						this.$message({
							type: "warning",
							message: "请定义销售价"
						});
						return false;
					}
					channelForm.supplierChannelCode = this.supplierChannelCode;
          			channelForm.supplierId = this.supplierId;
          			channelForm.channelForm = this.channelForm.channelForm;
					this.$request1({
						method: 'POST',
						url: '/system/channel/create',
						data: channelForm
					}).then(response => {
						if(response.data.success){
							this.$message.success('成功！')
							this.initChannel(this.conditions.search, this.conditions.type, this.conditions.status, this.conditions.open, this.currentPage, this.pageSize)
							this.$refs[formName].resetFields();
							this.emptyForm();
						} else{
							this.$message.error(response.data.message)
						}
					}).catch(error => {
						console.log(error)
					})
				} else{
					return false;
				}
			})
		},
		// 查询
		initChannel(nameCN, type, status, open, currentPage, pageSize) {
			if(nameCN === '' || nameCN === null) {
				nameCN = null
			}
			if(type === '' || type === null || type === 'all') {
				type = null
			}
			if(status === '' || status === null || status === 'all') {
				status = null
			}
			if(open === '' || open === null || open === 'all') {
				open = null
			}
			this.$request1({
				method: 'GET',
				url: '/system/channel/query',
				params: {
					nameCN: nameCN,
					type: type,
					status: status,
					open: open,
					currentPage: currentPage,
					pageSize: pageSize
				}
			}).then(response => {
				if(response.data.success) {
					if(response.data.data && response.data.data.length > 0){
						this.channelData = response.data.data;
						for(var i = 0; i < this.channelData.length; i++){
							this.channelData[i].status = this.channelData[i].status.toString();
							this.channelData[i].open = this.channelData[i].open.toString();
							this.channelData[i].print = this.channelData[i].print.toString();
							this.channelData[i].minTotalWeight = this.channelData[i].minTotalWeight.toString();
							this.channelData[i].countryCode = this.channelData[i].countryCode.split(",");
							this.channelData[i].priceDefinitions.forEach(price => {
								if(price.costCharge == null) {
									price.costCharge = {
										name: "costCharge",
          					formula: ""
									}
								}
							})
							this.channelData[i].effectiveTime =  this.channelData[i].priceDefinitions[0].effectiveFrom.toString();
							this.channelData[i].modifyTime = this.channelData[i].createAt;
						} 
						this.total = response.data.total;
					} else{
						this.channelData = []
					}
				} else{
					this.$message.error(response.data.message)
				}
				
			}).catch(error => {
				this.$message.error(error)
			})
		},
		reset() {
			this.conditions = {
				search: "",
				type: "AIR_SHIPPING",
				status: "1",
				open: ""
			}
			this.search()
		},
    //搜索
    search() {
      let nameCN = this.conditions.search.trim();
			let type = this.conditions.type;
			let status = this.conditions.status;
			let open = this.conditions.open;
			if (type == 'all'){
				type = null
			}
			if(status == 'all'){
				status = null
			}
			if(open == 'all'){
				open = null
			}
			this.initChannel(nameCN, type, status, open, this.currentPage, this.pageSize);
    },
    //编辑
    editChannel(index, row) {
			this.initCountry();
			this.findCurrentEffectivePriceDefinition(row.id);
			this.isEdit = true;
			this.dialogFormVisible = true;
			this.channelForm.id = row.id;
			this.channelForm.code = row.code;
			this.channelForm.type = row.type;
			this.channelForm.nameEN = row.nameEN;
			this.channelForm.maxWeightPerCarton = row.maxWeightPerCarton;
			this.channelForm.minWeightPerCarton = row.minWeightPerCarton;
			this.channelForm.minVolumePerCarton = row.minVolumePerCarton;
			this.channelForm.open = row.open;
			this.channelForm.nameCN = row.nameCN;
			this.channelForm.unitWeight = row.unitWeight;
			this.channelForm.estimateTransitTime = row.estimateTransitTime;
			this.channelForm.minTotalWeight = row.minTotalWeight;
			this.channelForm.minTotalVolume = row.minTotalVolume;
			this.channelForm.volumeWeightCalculationRadio = row.volumeWeightCalculationRadio;
			this.channelForm.billedWeightCalculationMethod = row.billedWeightCalculationMethod;
			this.channelForm.countryCode = row.countryCode;
			this.channelForm.remarks = row.remarks;
			this.channelForm.status = row.status;
			this.channelForm.print = row.print;
			this.channelForm.operator = row.operator;
			this.channelForm.commissionPrice = row.commissionPrice;
			this.channelForm.commissionRate = row.commissionRate;
			this.channelForm.volumeActualWeightRatio = row.volumeActualWeightRatio;
			this.supplierChannelCode = row.supplierChannelCode;
			this.supplierId = row.supplierId;
			this.channelForm.calculateChargeType = row.calculateChargeType;
			
			for(let j = 0; j < row.priceDefinitions.length; j++){
				let areas = row.priceDefinitions[j].mainCharge.logisticPrice.areas;
				for(let i = 0; i < areas.length; i++){
					let regionStr = areas[i].regions.join();
					let obj = {'regionStr': regionStr}
					areas[i]['regionStr'] = regionStr;
				}
			}
			
            this.channelForm.priceDefinitions = row.priceDefinitions;
            this.channelForm.warehouseId = [];
            if(row.warehouseIds!=null){
                this.channelForm.warehouseId = row.warehouseIds;
            }
            
    },
    //删除
    deleteChannel(index, rows) {
      this.$confirm("您确定要删除这条渠道信息吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
				let id = rows[index].id;
				this.$request1({
					method: 'POST',
					url: '/system/channel/delete',
					params:{
						id: id
					}
				}).then(response => {
					rows.splice(index, 1);
					// this.initChannel(null, null, null, null, this.currentPage, this.pageSize);
					this.initChannel(this.conditions.search, this.conditions.type, this.conditions.status, this.conditions.open, this.currentPage, this.pageSize)
					this.$message({
						message: "删除成功",
						type: "success",
						center: true,
						duration: 1500
					});
				}).catch(error => {
					console.log(error)
				})
			}).catch(() => {
				this.$message({
					type: "info",
					message: "已取消删除"
				});
			})
    },
    //分页
    handleSizeChange(val) {
      this.pageSize = val;
			// this.initChannel(null, null, null, null, this.currentPage, val)
				this.initChannel(this.conditions.search, this.conditions.type, this.conditions.status, this.conditions.open, this.currentPage, val)
    },
    handleCurrentChange(val) {
			// this.initChannel(null, null, null, null, val, this.pageSize);
				this.initChannel(this.conditions.search, this.conditions.type, this.conditions.status, this.conditions.open, val, this.pageSize)
    },
		// 清空表单
		emptyForm(){
			this.channelForm.id = "";
			this.channelForm.code = "";
			this.channelForm.type = "";
			this.channelForm.nameEN = "";
			this.channelForm.maxWeightPerCarton = "";
			this.channelForm.minWeightPerCarton = "";
			this.channelForm.minVolumePerCarton = "";
			this.channelForm.open = "1";
			this.channelForm.nameCN = "";
			this.channelForm.unitWeight = "";
			this.channelForm.estimateTransitTime = "";
			this.channelForm.minTotalWeight = "";
			this.channelForm.minTotalVolume = "";
			this.channelForm.volumeWeightCalculationRadio = "6000";
			this.channelForm.billedWeightCalculationMethod = "";
			this.channelForm.countryCode = [];
			this.channelForm.remarks = "";
			this.channelForm.operator = "";
			this.channelForm.status = "1";
			this.channelForm.print = "1";
			this.channelForm.priceDefinitions = [];
			this.dialogFormVisible = false;
			this.isEdit = false;
		},
		resetForm(formName){
			this.$refs[formName].resetFields();
			this.emptyForm();
		},
		getPriceDefinition (result) {
			this.dialogDefinitionVisible = false;
      result.updateOrAdd = "yes";
      if (this.priceDefinition.effectiveFrom === undefined) {
        this.priceDefinition = result;
        this.priceDefinition.id = "";
				this.channelForm.priceDefinitions.push(this.priceDefinition);
      } else {
        this.channelForm.priceDefinitions = this.channelForm.priceDefinitions.map(
          item => {
            if (item.id === result.id) {
              return result;
            } else {
              return item;
            }
          }
        );
      }
    },
    show () {
      if (this.hiddenYesOrNo === true) {
        this.hiddenYesOrNo = false;
      } else {
        this.hiddenYesOrNo = true;
      }
    },
    hiddenOrButton () {
      for (var i = 0; i < this.channelForm.priceDefinitions.length; i++) {
        if (
          this.productId != "" &&
          !this.dataCompare(this.channelForm.priceDefinitions[i].effectiveTo)
        ) {
          return true;
        }
      }
      return false;
		},
		addPriceDefinition() {
			if(!this.channelForm.code || !this.channelForm.type || !this.channelForm.nameCN || !this.channelForm.nameEN || !this.channelForm.unitWeight ||
			 !this.channelForm.estimateTransitTime || !this.channelForm.countryCode){
				 this.$message.warning("请补全渠道信息！");
				 return;
			 }
			this.priceDefinition = {}
			this.dialogDefinitionVisible = true
		},
		editPriceDefinition(val) {
			this.priceDefinition = val;
			// this.priceDefinition.effectiveFrom = new Date(this.priceDefinition.effectiveFrom).getTime();
      // this.priceDefinition.effectiveTo = new Date(this.priceDefinition.effectiveTo).getTime();
			if (val.id !== "") {
				this.salesPriceDefineds[val.id] = [true]
			}
			this.dialogDefinitionVisible = true
		},
		deletePrice(index, rows){
			 this.$confirm("您确定要删除这条渠道信息吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
				rows.splice(index, 1);
			})
		},
		// 添加偏远邮编  
	 async addFarawayZip (data,index) {
			this.sendPyZipObj.channelId=index.id
			this.ZipisShow=!this.ZipisShow;
			let id=index.id;
		await queryDefalutFarwayZip (id).then((res)=>{
					let remoteZip=res.data.remoteZipoCodeList.join()
					this.sendPyZipObj.zipcode=remoteZip;
					let moreRemoteZip=res.data.moreRemoteZipoCodeList.join();
					this.sendPyZipObj.zipcodecpy=moreRemoteZip;
				
			})
		},
		// 添加邮编保存按钮 
	async saveZip (formnode) {
		if(this.sendPyZipObj.zipcode==''&& this.sendPyZipObj.zipcodecpy=='') {
			this.$toast.warning('请输入邮编之后再提交')
			return false
			}
			let sendobj={
				channelZipCodeValueList:[],
				// morefarwayzip:[]  ["2222,3213213"] ["3123", "312321"]
			}
			let obj1=[{
				channelId:'',
				zipCodeList:[],
				flagType:1
			}]
			if (this.sendPyZipObj.zipcode!=='') {
				this.sendPyZipObj.zipcode.split(/[,\n]+/gim).forEach((d, i) => {
				if (d && d != "") {
				obj1[0].zipCodeList.push(d);
				}
			});
			obj1[0].channelId=this.sendPyZipObj.channelId;
			sendobj.channelZipCodeValueList.push(...obj1)
			} 
			if(this.sendPyZipObj.zipcodecpy!=='') {
				let obj=[{
				channelId:'',
				zipCodeList:[],
				flagType:2
				}]
				this.sendPyZipObj.zipcodecpy.split(/[,\n]+/gim).forEach((d, i) => {
				if (d && d != "") {
				obj[0].zipCodeList.push(d);
				}
			});
			obj[0].channelId=this.sendPyZipObj.channelId
			sendobj.channelZipCodeValueList.push(...obj)
			}
			// 开始axios请求 
		await farwayZip(sendobj).then((res)=>{
				if(res.data.success) {
					this.$toast.success('操作成功');
					this.ZipisShow=!this.ZipisShow;
					this.initChannel(this.conditions.search, this.conditions.type, this.conditions.status, this.conditions.open, this.currentPage, this.pageSize)
				}
			})	 
		},
		//渠道ID
		changeSupplier () {
		let sid = this.supplierId;
      this.channelForm.supplierChannelCode = "";
      this.supplierChannelCodes = [];
      this.channelProvider.forEach(a => {
        if (sid == a.id) {
          a.channel.forEach(b => {
            this.supplierChannelCodes.push(b);
          });
        }
      });
		},
		// 查询供应商请求
		  querySupplierProduct() {
      let _this = this;
      this.$request1({
        type: "get",
        url: '/channelsupplier/getSupplierChannel',
        xhrFields: {
          withCredentials: true
        }
      })
        .then(response => {
          _this.channelProvider = response.data.data;
          _this.supplierChannelCodes = [];
        //   _this.channelProvider.forEach(a => {
        //     a.channel.forEach(b => {
        //     //   _this.supplierChannelCodes.push(b);
        //     });
        //   });
        })
        .catch(error => {
          console.log(error);
        });
    },
  }
};
</script>
<style lang="scss" scoped>
.box-card {
  margin: 20px -10px;
}
.checkColor {
	color: #5CB85C;
}
.billWeightTips{
	position: absolute;
	top: 10px;
	left: 85%;
}
.special-options{
	margin-bottom: 15px;
	padding: 15px 0 15px 30px;;
	color: #99a9bf;
	border-top: 1px dashed rgb(220, 223, 230);
	border-bottom: 1px dashed rgb(220, 223, 230);
	>.title{
		margin-bottom: 15px;
		font-weight: 400;
	}
}
</style>


// WEBPACK FOOTER //
// src/views/system/channel.vue